import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadLeadFormSubmission } from '@tinct/core-api-models';
import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ApiError, tinctApi } from '../../api';
import { GetLandingPageLeadFormSubmissionsStaticParams } from '../../endpoints/lead-forms';

export const getLandingPageLeadFormSubmissions = async (
  params: GetCollectionQueryParams<
    ReadLeadFormSubmission,
    GetLandingPageLeadFormSubmissionsStaticParams
  >,
): Promise<ApiCollectionResponse<ReadLeadFormSubmission>> => {
  return await tinctApi.leadForms.getLandingPageLeadFormSubmissions(params);
};

export const useGetLandingPageLeadFormSubmissions = (
  params: GetCollectionQueryParams<
    ReadLeadFormSubmission,
    GetLandingPageLeadFormSubmissionsStaticParams
  >,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadLeadFormSubmission>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['lead-form-submissions', 'landing-page', params.staticParams?.landingPageId, params],
    queryFn: () => getLandingPageLeadFormSubmissions(params),
    ...options,
  });
